import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {Injectable} from '@angular/core';
import {catchError} from 'rxjs/operators';
import {IrbAppEvents} from "@irb/app.events";
import {AppService} from "@irb/app.service";
import {GlobalErrorHandler} from '@irb-common/services/global-error-handler';
import { UtilityService } from '../services/utility.service';

@Injectable()
export class ErrorHttpInterceptor implements HttpInterceptor {
    private displayInterval = 3000;
  private previousTime = new Date().getTime() - this.displayInterval - 1000;
  userdata: any;
  constructor(private util: UtilityService,
              public as: AppService, private globalErrorHandler: GlobalErrorHandler) {
                this.as.getUserDetails().subscribe((response) => {
                  this.userdata = response;
                });
              }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
        catchError((error: HttpErrorResponse) => {
            let errorMessage: any = '';

            if (error.error instanceof ErrorEvent) {
                // client-side error
                // errorMessage = `Error: ${error.error.message}`;
                // errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;

                errorMessage = {
                    originFrom: 'error-interceptor',
                    status: error.status,
                    message: error.message || error.error.message,
                }

            } else {
                // server-side error
                switch (error.status) {
                    case 401:
                      this.showErrorMessage(
                        {
                          summary: 'Session Expired',
                          detail: 'Please log in again.',
                        }
                      );
                      if (this.userdata?.veoRedirectUrl) {
                          window.location.replace(this.userdata.veoRedirectUrl);
                      }
                      break;                  
                    case 403:
                      if (this.checkForNotFinMasonValidationCall(error) && !error.error.errors && !this.checkIfAkamaiMalwareFound(request, error))
                        this.showErrorMessage(
                          {
                            summary: 'Access denied',
                            detail: 'You do not have permission.',
                          }
                        );
                      break;
                    case 413: //Request Entity Too Large
                      this.util.deleteAllCookies();
                      this.showErrorMessage(
                        {
                          summary: 'Internal Server Error',
                          detail: 'Request Entity Too Large.',
                        }
                      );
                      break;
                    case 431: //Request Header Fields Too Large
                      this.util.deleteAllCookies();
                      this.showErrorMessage(
                        {
                          summary: 'Internal Server Error',
                          detail: 'Request Header Fields Too Large.',
                        }
                      );
                      break;
                    case 500:
                      if (this.checkForNotFinMasonValidationCall(error) && !error.error.errors)
                        this.showErrorMessage(
                          {
                            summary: 'Internal Server Error',
                            detail: 'An error occurred processing your request.',
                          }
                        );
                      break;
                    default:
                      if (error.status >=400 && this.checkForNotFinMasonValidationCall(error) && !error.error.errors) {
                        this.showErrorMessage(
                          {
                            summary: 'Internal Server Error',
                            detail: 'An error occurred processing your request.',
                          }
                        );
                      }
                      break;

                  }

                  if (error.message) {
                      errorMessage = {
                          originFrom: 'error-interceptor',
                          status: error.status,
                          message: error.message,
                          errors: error.error.errors
                      }
                  }
            }

            // console.warn("An error occurred processing your request.", errorMessage);

            this.globalErrorHandler.handleError(errorMessage)
            return throwError(errorMessage);
        })
      );
  }

  private showErrorMessage(errorObject:any) {
    const currentTime = new Date().getTime();
    if ((currentTime - this.previousTime) > this.displayInterval) {
        this.previousTime = currentTime;
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: 'error',
            summary: errorObject.summary,
            detail: errorObject.detail,
            life: this.displayInterval
        });
    }
  }

  checkForNotFinMasonValidationCall(error: any) {
    return (error.url.indexOf('/token?suppressToken=true') === -1 && error.url.indexOf('/finmason/') === -1);
  }

  checkIfAkamaiMalwareFound(request: HttpRequest<any>, error: HttpErrorResponse) {
      let requestUrl: string = error.url;
      let originalBody: any = request?.body;
      let returnValue = false;

      if (originalBody instanceof FormData) {
          let listOfAkamaiUrls: string[] = [
              '/accounts/async-import-account-to-portfolio-assignments',
              '/accounts/async/validate-import-account-cash-settings',
              '/accounts/async/import-external-accounts',
              '/rebalance-portfolios/import-cash-settings/',
              '/rebalance-portfolios/import-loss-target-settings/',
              '/model/async/import-security-models',
              '/model/async/validate-import-blended-models',
              '/blotter-action/validate-import-orders',
              '/blotter-action/async/validate-import-orders',
              '/portfolios/import-model-and-category',
              '/portfolios/import-portfolio-name',
              '/async/import-securities',
              '/import-security-equivalents-async',
              '/async/import-tlh-wsa-validate',
              '/mmc/import-securities'
          ];

          const foundUrl = listOfAkamaiUrls.find(url => requestUrl.includes(url));
          if (foundUrl) {
              returnValue = true;
              let fileName = '';
              let formArray: any = Array.from(request.body);
              formArray.forEach((value: any) => {
                  if (!fileName && value && value.length)
                      fileName = value[1].name;
              });

              this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                  severity: 'error',
                  detail: `A virus or malware has been detected in file ${fileName}. Check your file and try again.`,
                  life: 5000
              });
          }
      }
      return returnValue;
  }

}
